import { render, staticRenderFns } from "./app.vue?vue&type=template&id=3386c210&scoped=true&"
import script from "./app.vue?vue&type=script&lang=js&"
export * from "./app.vue?vue&type=script&lang=js&"
import style0 from "./app.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./app.vue?vue&type=style&index=1&id=3386c210&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3386c210",
  null
  
)

component.options.__file = "app.vue"
export default component.exports